import React from "react";
import Icon from "../Icon";

const AnimatedCheckboxButton = ({ id, label, icon, checked, onChange, title }) => {
  return (
    <label className="animated-checkbox-button" title={title}>
      <input
        type="checkbox"
        id={id}
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
      />
      <div className="animated-checkbox-button-body">
        <div className="animated-checkbox-button-icon">
            <Icon src={icon} alt={label} />
        </div>
        <span className="animated-checkbox-button-text">
            {label}
        </span>
      </div>
    </label>
  );
};

export default AnimatedCheckboxButton;
